// extracted by mini-css-extract-plugin
module.exports = {"module":"JurisdictionFlag_module__1e-Pg","smaller":"JurisdictionFlag_smaller__3g063","small":"JurisdictionFlag_small__KtS-y","big":"JurisdictionFlag_big__3Uz9M"};